import { select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';

export default function* checkAuthCode(payload) {
  const apiHash = yield select((state) => state.configs.apiHash);

  try {
    yield nsApi.authenticate({
      username: payload.username,
      authCode: payload.authCode,
      apiHash,
    });

    return true;
  } catch (err) {
    return false;
  }
}
